/**
 * this hook is used to fetch the total count of product Subscriptions
 * this can be used when you need the total count of entitlements,
 * for example in csv download, we need to know the total count of entitlements to fetch all the entitlements
 */

import { useCallback, useEffect, useMemo, useState } from 'react';
import { abgGraphqlClient, ProxyGraphClients } from '@atlassian/temp-client-utils';
import {
  FetchEntitlementTotalCountQuery,
  FetchEntitlementTotalCountQueryVariables,
} from '@css-xp/graphtypes/src/generated-types-new';
import { fetchEntitlementTotalCount } from '../queries/fetch-entitlement-total-count';
import { fetchInternalLicensesTotalCount } from '../queries/fetch-internal-licenses-total-count';

export const useGetEntitlementTotalCount = (
  variables: FetchEntitlementTotalCountQueryVariables,
  shouldFetchInternalLicenses?: boolean
) => {
  const [entitlementTotalCount, setEntitlementTotalCount] = useState(0);
  const [error, setError] = useState<any>(null);

  const graphqlClient = useMemo(() => abgGraphqlClient(ProxyGraphClients.ANS), []);

  const fetchEntitlementTotalCountData = useCallback(() => {
    return graphqlClient.query<any, any>({
      query: shouldFetchInternalLicenses ? fetchInternalLicensesTotalCount : fetchEntitlementTotalCount,
      variables: variables,
      fetchPolicy: 'no-cache',
    });
  }, [variables]);

  useEffect(() => {
    fetchEntitlementTotalCountData()
      .then((res) => {
        const totalCount = shouldFetchInternalLicenses
          ? res?.data?.transactionAccount?.internalUseSubscriptions?.totalCount
          : res?.data?.transactionAccount?.productSubscriptionsInPPC?.totalCount;

        setEntitlementTotalCount(totalCount ?? 0);
      })
      .catch((err) => {
        setError(err);
      });
  }, [fetchEntitlementTotalCountData]);

  return {
    entitlementTotalCount,
    error,
  };
};
